import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "image-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.images.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["builder-slider scroll-wrapper", { 'select-design': $setup.props.isSelectDesign, 'select-facade': $setup.props.isSelectFacade }])
      }, [
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["builder-images-wr", { 'select-design': $setup.props.isSelectDesign, 'select-facade': $setup.props.isSelectFacade }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedImages, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["content-images", { checkmark: $props.isSelectDesign ? $setup.props.selectedimage?._id === image._id : $setup.props.selectedimage?.id === image.id, 'select-facade': $setup.props.isSelectFacade }]),
                  key: index,
                  onClick: ($event: any) => ($setup.onSelectImage(image))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["builder-carousel-img", { 'select-facade': $setup.props.isSelectFacade }]),
                    src: image.mainImages?.[0] || image.url || image.imagesUrls[0]
                  }, null, 10, _hoisted_2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["image-text-wr", { 'builder-estimator': $setup.props.showPrice, 'select-facade': $setup.props.isSelectFacade }])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["image-text", { 'select-facade': $setup.props.isSelectFacade, bold: $setup.props.showPrice }])
                    }, _toDisplayString(image?.name), 3),
                    ($setup.props.showPrice)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["image-text", { 'select-facade': $setup.props.isSelectFacade }])
                        }, _toDisplayString($setup.formatPrice(image?.price)), 3))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 10, _hoisted_1))
              }), 128))
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "builder-carousel-wr",
              ref: "builderCarousel",
              onScroll: $setup.handleScroll
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedImages, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["content-images", { checkmark: $props.isSelectDesign ? $setup.props.selectedimage?._id === image._id : $setup.props.selectedimage?.id === image.id }]),
                  key: index,
                  onClick: ($event: any) => ($setup.onSelectImage(image))
                }, [
                  _createElementVNode("img", {
                    class: "builder-carousel-img",
                    src: image.mainImages?.[0] || image.url
                  }, null, 8, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(image?.name), 1)
                ], 10, _hoisted_3))
              }), 128))
            ], 544))
      ], 2))
    : _createCommentVNode("", true)
}